import { getFileInternAgent, getInternCard, getInternStat } from "@core/actions/dashboardInternAction.ts";
import { FetchStatusType } from "@core/modeles/model.ts";
import { RootState } from "@core/store/store.ts";
import { CardType, DashboardInternData } from "@modules/dashbord/dashbord.model.ts";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DashboardInterState {
    loading: FetchStatusType;
    dataDashboard: DashboardInternData | null;
    fileExported: Blob | null;
    loadingExport: FetchStatusType;
    internCard: CardType[] | undefined;
    loadingCard: FetchStatusType;
    error: string | null;
}

const initialState: DashboardInterState = {
    loading: FetchStatusType.IDLE,
    dataDashboard: null,
    fileExported: null,
    loadingExport: FetchStatusType.IDLE,
    internCard: undefined,
    loadingCard: FetchStatusType.IDLE,
    error: null,
}

const DashboardInternSlice = createSlice({
    name: "dashboardIntern",
    initialState,
    reducers: {
        setDataDashboard: (state, action: PayloadAction<DashboardInternData>) => {
            return { ...state, dataDashboard: action.payload };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getInternStat.pending, (state) => {
                return { ...state, loading: FetchStatusType.LOADING };
            })
            .addCase(getInternStat.fulfilled, (state, action) => {
                return {
                    ...state,
                    loading: FetchStatusType.COMPLETED,
                    dataDashboard: action.payload,
                }
            });

        builder
            .addCase(getFileInternAgent.pending, (state) => {
                state.loadingExport = FetchStatusType.LOADING;
                state.error = null;
            })
            .addCase(getFileInternAgent.fulfilled, (state) => {
                state.loadingExport = FetchStatusType.COMPLETED;
            })
            .addCase(getFileInternAgent.rejected, (state, action) => {
                state.loadingExport = FetchStatusType.FAILED;
                state.error = action.payload as string;
            });

        builder
            .addCase(getInternCard.pending, (state) => {
                state.loadingCard = FetchStatusType.LOADING;
            })
            .addCase(getInternCard.fulfilled, (state, action) => {
                state.loadingCard = FetchStatusType.COMPLETED;
                state.internCard = action.payload
            })
    },
})

export const {
    setDataDashboard
} = DashboardInternSlice.actions;

export const dashboardInternData = (state: RootState) => state.dashboard;
export const loadingExport = (state: RootState) => state.dashboard.loadingExport;
export const internCard = (state: RootState) => state.dashboard.internCard;

export default DashboardInternSlice.reducer;